import { SunMoon } from 'lucide-react';
import { useSyncExternalStore } from 'react';

import { aplicarTema, salvarTema, type Tema } from '@/lib/tema';

import { Botao } from './Botao';

/**
 * Alternador de tema (v2.1, p.40). O claro e o PADRAO — e o que imprime, o que
 * vai para apresentacao e o que o cliente ve. O escuro existe para turno da
 * noite e sala de controle, com as mesmas funcoes; os pares de cada token
 * estao completos na p.62, e moram em docs/design/tokens.css.
 *
 * Na barra superior ele e o botao redondo so com o icone de tema (`sun-moon`,
 * p.19), com nome e dica; no pe da gaveta do menu, o mesmo botao com o rotulo.
 *
 * A escolha vai para o `localStorage` dentro de `try/catch` (ver `lib/tema`):
 * navegador com armazenamento bloqueado LEVANTA em vez de devolver nulo, e
 * ninguem deveria perder o sistema inteiro por causa de uma preferencia de cor.
 *
 * O TEMA E LIDO DA RAIZ, e nao guardado aqui. Ha dois alternadores — na barra
 * superior e, abaixo de 1024 px, no pe da gaveta do menu — e cada um com o
 * proprio estado discordaria do outro.
 */
function temaDaRaiz(): Tema {
  return document.documentElement.dataset['tema'] === 'escuro' ? 'escuro' : 'claro';
}

function observarRaiz(avisar: () => void): () => void {
  const observador = new MutationObserver(avisar);
  observador.observe(document.documentElement, { attributes: true, attributeFilter: ['data-tema'] });
  return () => {
    observador.disconnect();
  };
}

export function AlternadorTema({ forma = 'icone' }: { readonly forma?: 'icone' | 'texto' }) {
  const tema = useSyncExternalStore(observarRaiz, temaDaRaiz, (): Tema => 'claro');

  function alternar() {
    const proximo: Tema = tema === 'claro' ? 'escuro' : 'claro';
    aplicarTema(proximo);
    salvarTema(proximo);
  }

  const rotulo = tema === 'claro' ? 'Usar tema escuro' : 'Usar tema claro';

  return (
    <Botao
      nivel="fantasma"
      {...(forma === 'icone' ? { tamanho: 'p' as const, icone: true, 'aria-label': rotulo, title: rotulo } : {})}
      onClick={alternar}
      aria-pressed={tema === 'escuro'}
    >
      <SunMoon aria-hidden="true" className="size-[var(--icone-controle)] shrink-0" />
      {forma === 'icone' ? null : rotulo}
    </Botao>
  );
}
